/**
 * iter86.31.1 — Golf Live Sync card (tournament admin → Live Sync tab).
 *
 * iter86.31.12 — Read-only cached data view: rivalry admins no longer
 * trigger vendor syncs. The platform poller refreshes scores on cadence
 * through the cached vendor feed; this card just shows the state.
 */
import { Radio } from "lucide-react";

export default function GolfSyncCard({ tournament }) {
    const golf = tournament?.golf || {};

    return (
        <div className="brutal-card p-5 space-y-4" data-testid="golf-sync-card">
            <div className="flex items-center gap-2">
                <div className="w-9 h-9 bg-neon border-2 border-black shadow-brutal flex items-center justify-center shrink-0">
                    <Radio className="w-4 h-4 text-black" strokeWidth={2.5} />
                </div>
                <div>
                    <h2 className="font-display font-extrabold text-xl uppercase leading-tight">Live Sync — Slash Golf</h2>
                    <p className="text-[10px] uppercase tracking-widest text-zinc-500">
                        {golf.event_name || "Golf event"} · {golf.season}
                    </p>
                </div>
            </div>

            <div className="grid sm:grid-cols-3 gap-3">
                <div className="brutal-card-light p-3">
                    <p className="text-[9px] uppercase tracking-widest text-zinc-500">Round</p>
                    <p className="font-mono font-black text-2xl" data-testid="golf-sync-round">
                        {golf.current_round || "—"}
                    </p>
                    <p className="text-[10px] text-zinc-500">{golf.round_status || "Not Started"}</p>
                </div>
                <div className="brutal-card-light p-3">
                    <p className="text-[9px] uppercase tracking-widest text-zinc-500">Last updated</p>
                    <p className="font-mono font-bold text-sm mt-1" data-testid="golf-sync-last-updated">
                        {golf.last_synced_at ? new Date(golf.last_synced_at).toLocaleString() : "Never"}
                    </p>
                </div>
                <div className="brutal-card-light p-3">
                    <p className="text-[9px] uppercase tracking-widest text-zinc-500">Flags</p>
                    <p className="text-[11px] text-zinc-300 mt-1 leading-relaxed">
                        {golf.r1_started ? "🔒 Picks locked (R1 started)" : "🟢 Picks open"}<br />
                        {golf.cut_made ? "✂️ Cut made" : "— Cut not made"}
                    </p>
                </div>
            </div>

            {/* iter86.31.2 — Quota telemetry intentionally NOT shown here:
                that's platform-admin territory (Vendor Registry live-status
                + vendor health in Release Ops). */}
            <div className="brutal-card-light p-3 flex flex-wrap items-center justify-between gap-3">
                <p className="text-xs text-zinc-400 leading-relaxed flex-1 min-w-[12rem]">
                    Scores auto-refresh <b className="text-zinc-200">every 15 minutes during play</b> from the cached
                    vendor feed. Sync is managed by the platform — no manual action needed.
                </p>
                <span
                    data-testid="golf-sync-auto-chip"
                    className="pill bg-neon/10 border-neon text-neon text-[10px] font-bold px-2.5 py-1 shrink-0"
                >
                    Auto-synced · cached feed
                </span>
            </div>
        </div>
    );
}
